/* Cards Infinity custom sections — scroll reveal */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enabled = getComputedStyle(document.documentElement).getPropertyValue('--ci-animations').trim() !== '0';
  if (enabled && !reduce) document.documentElement.classList.add('ci-anim');

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ci-reveal:not(.ci-in)');
    if (!document.documentElement.classList.contains('ci-anim') || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('ci-in'); });
      return;
    }
    var stagger = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ci-reveal-stagger')) || 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('ci-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e, i) {
      e.style.setProperty('--ci-reveal-delay', (i % 4) * stagger + 'ms');
      io.observe(e);
    });
  }

  function initFeaturedSliders(root) {
    var context = root || document;
    var sections = [];
    if (context.matches && context.matches('[data-ci-featured-section]')) sections.push(context);
    context.querySelectorAll('[data-ci-featured-section]').forEach(function (section) {
      sections.push(section);
    });
    sections.forEach(function (section) {
      var slider = section.querySelector('[data-ci-featured-slider]');
      var dots = section.querySelectorAll('[data-ci-featured-dot]');
      if (!slider || !dots.length || slider.dataset.ciDotsReady === 'true') return;

      slider.dataset.ciDotsReady = 'true';

      function setActive(index) {
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      function getActiveIndex() {
        var slides = slider.querySelectorAll('.ci-card');
        if (!slides.length) return 0;
        var sliderLeft = slider.getBoundingClientRect().left;
        var closestIndex = 0;
        var closestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.getBoundingClientRect().left - sliderLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      var scrollTimer;
      slider.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          setActive(getActiveIndex());
        }, 80);
      }, { passive: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index'), 10) || 0;
          var slide = slider.querySelectorAll('.ci-card')[index];
          if (!slide) return;
          slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
          setActive(index);
        });
      });
    });
  }

  function init(root) {
    initReveal(root);
    initFeaturedSliders(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
